import { combineReducers } from 'redux';
//import { ActionNames } from './Actions';
import * as ActiveReducers from '../activate/reducers/activate-landing-page-reducer';
import * as AlbumReducers from '../album-view/reducers/index';
import * as SettingsReducers from '../settings/reducers/settings-reducers';
import * as ApplicationStateReducers from '../settings/reducers/application-state-reducers';
import * as ViewReducers from '../view/reducers/view-reducers';
import * as DiscReducers from '../disc/reducers/disc-reducers';
import * as SnapfishReducer from '../snapfish/reducers/snapfish-reducer';
import * as UploadReducers from '../upload/reducers/upload-reducers';
import * as ProfileReducers from '../profile/reducers/profile-reducers';
import * as SignupReducers from '../signup/reducers/signup-reducer';
import * as forgotPassword from '../signup/reducers/forgot-password-reducer';
import * as resetPassword from '../signup/reducers/reset-password-reducer';
import * as TimelineReducers from '../timeline/reducers/timeline-reducers';
import * as cart from '../cart/reducers/cart-reducers';
import * as uploadControllerReducers from '../uploadController/reducers/uploadController-reducers';
import * as infoPanelReducers from '../infoPanel/reducers/infoPanel-reducer';
import * as assetContainerRedicers from '../assetContainer/reducers/asset-container-reducers';
import * as accountReducers from '../account/reducers/payment-accounts-reducer';
import * as preloaderReducers from '../preloader/reducers/preloader-reducer';
import { routerReducer } from 'react-router-redux';
import * as subscriptionPlanReducer from '../account/reducers/subscription-plan-reducer';
import * as historyReducer  from "./reducers/history-reducer";
import * as webconfigReducer  from "../settings/reducers/webconfig-reducer";
import * as orderReducer from "../orderStatus/reducers/order-status-reducer";
import * as commonReducer from "./reducers/dialog-reducer"

const appReducer = combineReducers({
    ...ActiveReducers,
    ...ViewReducers,
    ...AlbumReducers,
    ...SettingsReducers,
    ...ApplicationStateReducers,
    ...DiscReducers,
    ...SnapfishReducer,
    ...UploadReducers,
    ...ProfileReducers,
    ...SignupReducers,
    ...TimelineReducers,
    ...forgotPassword,
    ...resetPassword,
    ...cart,
    ...uploadControllerReducers,
    ...infoPanelReducers,
    ...assetContainerRedicers,
    ...accountReducers,
    ...preloaderReducers,
    ...subscriptionPlanReducer,
    ...historyReducer,
    ...webconfigReducer,
    ...orderReducer,
    ...commonReducer,
    routing: routerReducer
});

const reducers = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        state = undefined
    }
    return appReducer(state, action)
}

export default reducers;


// WEBPACK FOOTER //
// ./src/common/reducers.js